import React from "react";
import styled from "styled-components";

export const Legend = () => {
    return (
        <Container>
            <Color>
                <ColorBlock color={"chartreuse"} /> Normal
            </Color>
            <Color>
                <ColorBlock color={"#43DAFF"} /> Low Risk
            </Color>
            <Color>
                <ColorBlock color={"yellow"} /> Medium Risk
            </Color>
            <Color>
                <ColorBlock color={"red"} /> High Risk
            </Color>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

const Color = styled.div`
    display: flex;
    align-items: center;
    gap: 1vw;
    overflow: hidden;
    white-space: nowrap;
`;

const ColorBlock = styled.div<{ color: string }>`
    background-color: ${(props) => props.color};
    width: 1em;
    height: 1em;
`;
